import { HttpStatusCode } from '@angular/common/http';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import { FileService } from 'src/app/services/file.service';
import { SafeLogger } from 'src/app/utils/safe-logger';
import { CopyleaksServiceHelper } from 'src/app/services/copyleaks.service';
import { UserTypes } from 'src/app/models/userTypes';
import { HeaderComponent } from '../header/header.component';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.css'],
    animations: [],
    imports: [HeaderComponent, NgIf, FormsModule, MatProgressSpinner, MatButton]
})
export class UploadComponent implements OnInit {

  file!: File;
  fileName!: string;

  scanUrl: string = "";
  scanId: string = "";
  role:UserTypes = UserTypes.EMA;

  retryDelay = 15000;
  retryCount = 20;
  scanComplete = false;
  scanError = false;

  displayRetryCount = 0;
  displayTimer = this.retryDelay;

  isInternalDb = false;
  isOnline = false;
  isStudent = false;
  isTaskId = false;
  taskId = null;
  studentId = null;
  wguId = null;

  submissionToDisplay = {
    studentId: 0,
    submissionId: 0
  }

  constructor(
    private fileService: FileService,
    private cd: ChangeDetectorRef,
    private clipboard: Clipboard,
    private copyleaksServiceHelper: CopyleaksServiceHelper,
  ) { }

  ngOnInit(): void {
    
  }

  onFileUpload(event: any) {  
    const file = event.target.files[0];

    if (file) {
      this.file = file;
      this.uploadSingleFileApiGateway(file);
    }

  }

  copyUrl() {
    this.clipboard.copy(this.scanUrl);
  }

  refresh() {
    window.location.reload();
  }

  onStudentValueChange = (event: any) => {
    if(!event) {
      this.studentId = null;
      this.wguId = null;
    }
  }

  onTaskValueChange = (event: any) => {
    if(!event) {
      this.taskId = null;
    }
  }

  uploadSingleFileApiGateway = (file: File) => {
    const metaData = {
      isInternalDb: this.isInternalDb,
      isOnline: this.isOnline,
      isStudent: this.isStudent,
      taskId: this.taskId,
      studentId: this.studentId,
      wguId: this.wguId
    }
    const filePlaceholder = ({
      name: file.name,
      mimeType: (file.type || 'application/octet-stream'),
      size: file.size,
      metadata: JSON.stringify(metaData)
    });
    const filePayload = {
      filename: filePlaceholder.name,
      contentType: filePlaceholder.mimeType,
      size: filePlaceholder.size,
      metadata: JSON.stringify(metaData)
    };
    this.fileService.getPresignedURL(filePayload).subscribe(urlResponse => {
    
      let urlParts = urlResponse.first.split("/");
      let scanId = urlParts[1];

      console.log("URL RESPONSE", urlResponse);
    
      this.cd.detectChanges(); // needed as file system file entry stuff is out of angular's change detection zones
      this.fileService.uploadFileWithPresignedUrl(urlResponse.second, file, filePlaceholder).subscribe({
        next: (response: any) => {
      
          if(response.status === HttpStatusCode.Ok && scanId) {
            let currentUrl = window.location.href.replace("upload", "scan");
            this.scanUrl = currentUrl + "/" + scanId;
            this.scanId = scanId;

            this.checkForCompleteResult(this.retryCount);
            this.copyleaksServiceHelper.checkCompleteResult(this.scanId, this.role, this.retryCount, this.retryDelay).subscribe({
              next: (res: any) => {
                window.open(this.scanUrl, '_blank');
                this.scanComplete = true;
              },
              error: (err: any) => {
                console.log("ERR:" + err)
              }
            })
          }

        },
        error: err => {
            SafeLogger.log('error uploading file', err);
            this.cd.detectChanges();
          }
      });
    });
  }

  checkForCompleteResult(count: number) {
    let interval = setInterval(() => {
      if(this.scanComplete) { clearInterval(interval); }
      if(this.displayRetryCount == this.retryCount - 1) {
        this.scanError = true;
        clearInterval(interval);
      }
      if(this.displayTimer <= 0){
        this.displayTimer = this.retryDelay;
        this.displayRetryCount = this.displayRetryCount + 1;
      } else {
        this.displayTimer = this.displayTimer - 1000;
      }
    }, 1000)
  }

  isUploadDisabled(): boolean {
    if (!this.isOnline && !this.isInternalDb) {
      return true;
    }
    return this.isStudent ? (this.studentId == null && this.wguId == null) : false;
  }

}
